module.exports = "/assets/1c3000b231af0010568defbbffeb8cfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/QS.png
// module id = 1762
// module chunks = 0